<template>
    <div class="left-side-menu left-side-menu-dark">
        <template v-if="showShopSwitcher">
            <ShopSwitcher />
            <hr class="mt-0">
        </template>
        <template v-if="showSpaceSwitcher">
            <SpaceSwitcher />
            <hr class="mt-0">
        </template>
        <div class="sidebar-content">
            <vue-perfect-scrollbar :settings="settings">
                <div class="sidebar-menu">
                    <ul>
                        <template v-for="(firstLevel, firstLevelKey) in items">
                            <li
                                v-if="firstLevel.isActive !== false"
                                :key="JSON.stringify(firstLevel)"
                                class="side-nav-title side-nav-item first-level"
                                :class="{ 'subnav nav-second-level': firstLevel.children, 'expanded': expanded.includes(`${firstLevelKey}`), 'active': activeKeyTree.includes(`${firstLevelKey}`), 'root': firstLevel.root }"
                            >
                                <b-link v-bind="!firstLevel.children ? { to: firstLevel.to, href: firstLevel.href, target: firstLevel.target } : { href: '#' }" @click="menuItemClick(firstLevel, `${firstLevelKey}`)">
                                    <img v-if="firstLevel.img" class="nav-link-icon" :src="getIconPath(firstLevel.img)" alt="">
                                    <feather v-else-if="firstLevel.icon" :type="firstLevel.icon" />
                                    <span class="link-label">{{ firstLevel.label }}</span>
                                    <feather v-if="firstLevel.children" class="menu-arrow" size="12" type="chevron-right" />
                                </b-link>
                                <template v-if="firstLevel.children">
                                    <b-collapse :visible="expanded.includes(`${firstLevelKey}`)">
                                        <ul class="nav-second-level" :class="{ 'ul-root-parent': firstLevel.root }">
                                            <template v-for="(secondLevel, secondLevelKey) in firstLevel.children">
                                                <li
                                                    v-if="secondLevel.isActive !== false"
                                                    :key="JSON.stringify(secondLevel)"
                                                    class="second-level"
                                                    :class="{ 'expanded': expanded.includes(`${firstLevelKey}.${secondLevelKey}`), 'active': activeKeyTree.includes(`${firstLevelKey}.${secondLevelKey}`), 'li-root-parent': firstLevel.root }"
                                                >
                                                    <b-link v-bind="!secondLevel.children ? { to: secondLevel.to, href: secondLevel.href, target: secondLevel.target } : { href: '#' }" @click="menuItemClick(secondLevel, `${firstLevelKey}.${secondLevelKey}`)">
                                                        <img v-if="firstLevel.root && secondLevel.img" class="nav-link-icon" :src="getIconPath(secondLevel.img)" alt="">
                                                        <feather v-else-if="firstLevel.root && secondLevel.icon" :type="secondLevel.icon" />
                                                        <span class="link-label">{{ secondLevel.label }}</span>
                                                        <feather v-if="secondLevel.children" class="menu-arrow" size="12" type="chevron-right" />
                                                    </b-link>
                                                    <template v-if="secondLevel.children">
                                                        <b-collapse :visible="expanded.includes(`${firstLevelKey}.${secondLevelKey}`)">
                                                            <ul class="nav-third-level">
                                                                <template v-for="(thirdLevel, thirdLevelKey) in secondLevel.children">
                                                                    <li
                                                                        v-if="thirdLevel.isActive !== false"
                                                                        :key="JSON.stringify(thirdLevel)"
                                                                        class="third-level"
                                                                        :class="{ 'active': activeKeyTree.includes(`${firstLevelKey}.${secondLevelKey}.${thirdLevelKey}`) }"
                                                                    >
                                                                        <b-link :to="thirdLevel.to" @click="menuItemClick(thirdLevel, `${firstLevelKey}.${secondLevelKey}.${thirdLevelKey}`)">
                                                                            {{ thirdLevel.label }}
                                                                        </b-link>
                                                                    </li>
                                                                </template>
                                                            </ul>
                                                        </b-collapse>
                                                    </template>
                                                </li>
                                            </template>
                                        </ul>
                                    </b-collapse>
                                </template>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="sidebar-bottom-content d-flex justify-content-center">
                    <ButtonIcon v-if="isRoleWidgeter" variant="outline-light" icon="smile" :to="{ name: 'BBAffiliateProgram' }">{{ $t('sidebar.bbAffiliateProgram') }}</ButtonIcon>
                </div>
            </vue-perfect-scrollbar>
        </div>
    </div>
</template>



<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import ShopSwitcher from '@/components/common/ShopSwitcher.vue';
    import usercomService from '@/services/usercomService';
    import { traverseTree } from '@/utils/util';
    import SpaceSwitcher from './common/SpaceSwitcher.vue';

    export default {
        name: 'AppSidebar',
        components: {
            VuePerfectScrollbar,
            ShopSwitcher,
            SpaceSwitcher,
        },
        props: {
            items: {
                type: Array,
            },
        },
        data() {
            return {
                settings: {
                    minScrollbarLength: 60,
                },
                itemsMap: new Map(),
                activeKey: '',
                rootKeys: new Set(),
                expanded: [],
            };
        },
        computed: {
            userRole() {
                return this.$store.getters['auth/getRoleName'];
            },
            isRoleWidgeter() {
                return this.$store.getters['auth/isRoleWidgeter'];
            },
            showShopSwitcher() {
                return this.$store.getters['auth/isRoleAdvertiser'];
            },
            showSpaceSwitcher() {
                return this.$store.getters['auth/isRoleProducer'];
            },
            currentSpace() {
                return this.$store.getters['space/currentSpace'];
            },
            currentSpaceName() {
                return this.currentSpace?.name || '';
            },
            activeKeyTree() {
                return this.getKeyTree(this.activeKey);
            },
        },
        watch: {
            items: {
                immediate: true,
                handler() {
                    if (Array.isArray(this.items)) {
                        const previousExpanded = [...this.expanded];
                        const isInitialLoad = previousExpanded.length === 0;

                        // Przebuduj mapę elementów menu i zbiór kluczy root-ów
                        this.itemsMap = new Map();
                        this.rootKeys = new Set();
                        traverseTree(this.items, (item, path, depth) => {
                            const pathString = path.join('.'); // Klucz w formacie "0", "1.2", "2.1.3" itp.
                            const itemClone = structuredClone(item);
                            const flatItem = { ...itemClone, path, children: Boolean(item.children?.length) };
                            this.itemsMap.set(pathString, flatItem);
                            if (item.root) {
                                this.rootKeys.add(pathString);
                            }
                        });

                        // WAŻNE: Przy pierwszym załadowaniu - rozwiń wszystkie rooty
                        // Przy kolejnych zmianach items - zachowaj poprzedni stan expanded
                        // (zapobiega to niechcianemu rozwijaniu wszystkich root-ów przy każdej zmianie items)
                        this.expanded = isInitialLoad ? Array.from(this.rootKeys) : previousExpanded;
                    }
                },
            },
            '$route.path': {
                handler() {
                    this.initActiveKey();
                    this.$nextTick(() => {
                        if (this.activeKey) {
                            // Route jest w menu - rozwiń do aktywnego elementu
                            this.setExpand(this.activeKey);
                        } else {
                            // Route nie jest w menu - zostaw tylko rooty w expanded
                            this.expanded = this.expanded.filter(key => this.rootKeys.has(key));
                        }
                    });
                },
            },
        },
        methods: {
            /**
             * Buduje ścieżkę kluczy od root do danego elementu
             * Przykład: dla klucza "2.1.3" zwraca ["2", "2.1", "2.1.3"]
             * Używane do rozwijania całej hierarchii menu do wybranego elementu
             */
            getKeyTree(key) {
                if (!key) return [];
                const currentKeys = [];
                const keysPathArray = key.split('.');
                for (let index = keysPathArray.length; index > 0; index -= 1) {
                    const currentKey = keysPathArray.slice(0, index).join('.');
                    currentKeys.unshift(currentKey);
                }
                return currentKeys;
            },
            setActiveKey(key) {
                this.activeKey = key;
            },
            /**
             * Zarządza rozwijaniem/zwijaniem elementów menu
             * Logika:
             * - Elementy typu leaf (bez dzieci) - zawsze rozwijają całą ścieżkę (bez toggle)
             * - Elementy z dziećmi - mają toggle (kliknięcie rozwija/zwija)
             * - Rooty są zachowywane w stanie rozwiniętym (chyba że klikamy właśnie w root - wtedy toggle)
             * - Pozwala na jednoczesne rozwinięcie wielu gałęzi menu
             */
            setExpand(itemKey) {
                if (!itemKey) {
                    return;
                }
                const currentItem = this.itemsMap.get(itemKey);
                if (!currentItem) {
                    return;
                }
                const isLeaf = !currentItem.children;
                const expanded = new Set();

                // Zachowaj wszystkie rozwinięte rooty (pozwala na wiele rozwiniętych gałęzi jednocześnie)
                // CHYBA ŻE klikamy właśnie w ten root - wtedy pozwól na toggle
                this.rootKeys.forEach(key => {
                    if (this.expanded.includes(key) && key !== itemKey) {
                        expanded.add(key);
                    }
                });

                if (isLeaf) {
                    // Leaf node (element końcowy bez dzieci):
                    // Zawsze rozwiń całą ścieżkę do tego elementu (bez toggle)
                    // Przykład: kliknięcie w "2.1" rozwija ["2", "2.1"]
                    this.getKeyTree(itemKey).forEach(key => expanded.add(key));
                } else if (this.expanded.includes(itemKey)) {
                    // Node z dziećmi - JUŻ rozwinięty:
                    // Zwiń ten node, ale zachowaj ścieżkę do rodzica
                    // Przykład: kliknięcie w rozwinięte "2" da ["1"] (jeśli "1" też był rozwinięty)
                    this.getKeyTree(itemKey)
                        .slice(0, -1)
                        .forEach(key => expanded.add(key));
                } else {
                    // Node z dziećmi - NIE rozwinięty:
                    // Rozwiń całą ścieżkę włącznie z tym node
                    // Przykład: kliknięcie w zwinięte "2" da ["2"]
                    this.getKeyTree(itemKey).forEach(key => expanded.add(key));
                }

                this.expanded = Array.from(expanded);
            },
            menuItemClick(item, key) {
                this.setExpand(key);
                const isLeaf = Boolean(!item.children?.length);
                if (isLeaf) {
                    this.menuItemClickEvent(item);
                }
            },
            menuItemClickEvent(item) {
                usercomService.userengage(`event.menu-${item.label}`, { 'space-type': this.currentSpaceName });
            },
            initActiveKey() {
                let found = false;
                traverseTree(this.items, (item, path) => {
                    const pathString = path.join('.');
                    const matchedRoute = this.$route.matched.find(route => route.name && route.name === item?.to?.name);
                    if (matchedRoute) {
                        this.setActiveKey(pathString);
                        found = true;
                    }
                });
                // Jeśli route nie jest w menu - wyczyść activeKey
                if (!found) {
                    this.setActiveKey('');
                }
            },
            getIconPath(name) {
                return require(`@/assets/images/menu-icons/${name}`); // eslint-disable-line
            },
        },
        mounted() {
            // Inicjalizacja przy montowaniu komponentu:
            // 1. Znajdź aktywny element menu na podstawie aktualnej trasy
            this.initActiveKey();
            // 2. Rozwiń menu do aktywnego elementu
            this.setExpand(this.activeKey);
        },
    };
</script>



<style lang="scss">
    .ps > .ps__scrollbar-y-rail {
        width: 8px !important;
        background-color: transparent !important;
    }
    .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
    .ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
    .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
    .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
        width: 6px !important;
    }
    .abstract-items {
        display: none;
    }
    .btn-quick-start {
        margin-left: 30px;
    }

    .left-side-menu {
        background-color: $bg-leftbar-dark;
        box-shadow: none;

        .sidebar-content {
            .ps-container {
                display: flex;
                flex-direction: column;
                height: 100%;
                gap: 3rem;
            }

            .sidebar-menu {
                .menu-title {
                    color: $gray-500;
                }

                .menu-arrow {
                    top: calc(50% - 6px);
                }

                ul {
                    li {
                        transition: all 0.3s ease;
                        list-style: none;

                        a {
                            transition: all 0.3s ease;
                            padding: 12px 30px;
                            border-left: 3px solid transparent;
                        }

                        .menu-arrow svg {
                            color: $menu-item-active-color-dark;
                            fill: rgba($white, 0.12);
                        }

                        &.expanded,
                        &.active,
                        &.mm-active {
                            > a {
                                color: $menu-item-active-color-dark;
                                background-color: lighten($bg-leftbar-dark, 4%);

                                .menu-arrow svg {
                                    color: $menu-item-active-color-dark;
                                    fill: rgba($white, 0.12);
                                }
                            }
                        }
                    }
                }
            }

            .sidebar-menu > ul,
            .sidebar-menu ul.ul-root-parent {
                margin: 0;
                padding: 0;

                > li {
                    a {
                        color: $menu-item-color-dark;

                        &:hover {
                            color: $menu-item-color-dark;
                        }

                        &.router-link-active {
                            color: $menu-item-active-color-dark;

                            &:hover {
                                color: $menu-item-active-color-dark;
                            }
                        }
                    }

                    > a {
                        font-size: 1rem;
                        display: flex;
                        align-items: center;

                        &:hover {
                            color: $menu-item-hover-color-dark;
                            background-color: lighten($bg-leftbar-dark, 4%);
                            text-decoration: none;
                        }
                    }

                    &.expanded,
                    &.active,
                    &.mm-active {
                        > a {
                            color: $menu-item-active-color-dark;
                            background-color: lighten($bg-leftbar-dark, 4%);
                        }
                        li {
                            a {
                                background-color: transparent;
                            }
                        }
                    }

                    &:not(.root) {
                        &.expanded {
                            background-color: lighten($bg-leftbar-dark, 2%);

                            &:not(.active) {
                                a {
                                    border-left-color: transparent;
                                    color: $menu-item-color-dark;

                                    svg {
                                        color: $menu-item-color-dark;
                                    }
                                }
                            }
                        }

                        &.active,
                        &.mm-active {
                            > a {
                                border-left: 3px solid $menu-item-active;
                                background-color: lighten($bg-leftbar-dark, 4%);
                            }
                        }
                    }

                    &.root.expanded,
                    &.root.active,
                    &.root.mm-active,
                    &.root {
                        > a {
                            padding-top: 20px;
                            padding-bottom: 20px;
                            background-color: lighten($bg-leftbar-dark, 8%);
                        }
                    }
                }
            }

            .nav-link-icon {
                width: 24px;
                height: 24px;
                margin: 0 14px 0 3px;
            }
        }
    }
</style>
